"use client";

import { useQuery } from "@tanstack/react-query";

import { Diagnosis } from "@/src/models/documents/referral";
import { getProvidersForDiagnosis, ProviderForDiagnosis } from "@/src/requests/diagnosis-providers";

export function useProvidersForDiagnostics(diagnosisList: Diagnosis[] | null, departmentId?: string) {
  return useQuery<ProviderForDiagnosis[]>({
    queryKey: ["providers-for-diagnosis", diagnosisList, departmentId],
    queryFn: () => getProvidersForDiagnosis(diagnosisList!, departmentId),
    enabled: !!diagnosisList,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
